import React from "react";
import {
  Grid,
  Button,
  Typography,
  Skeleton,
  TextField,
  InputAdornment,
  ButtonGroup,
} from "@mui/material";
import { Add, Search } from "@mui/icons-material";

interface HeaderVehicleProps {
  loading: boolean;
  searchValue: string;
  handleNewVehicle: () => void;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setComCliente: (value: boolean | null) => void;
  comCliente: boolean | null;
  vehicles: number | null;
}

const HeaderVehicle: React.FC<HeaderVehicleProps> = ({
  loading,
  searchValue,
  handleNewVehicle,
  handleSearchChange,
  setComCliente,
  comCliente,
  vehicles,
}) => {
  const handleComClienteChange = () => {
    setComCliente(comCliente === true ? null : true);
  };

  const handleSemClienteChange = () => {
    setComCliente(comCliente === false ? null : false);
  };
  return (
    <>
      <Grid item xs={12}>
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={50}
            sx={{ borderRadius: 2, bgcolor: "grey.400" }}
          />
        ) : (
          <Button
            variant="contained"
            fullWidth
            sx={{
              height: 50,
              backgroundColor: "#1d1d1d",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              ":hover": { bgcolor: "#5c5c5c" },
            }}
            onClick={handleNewVehicle}
          >
            <Typography
              sx={{
                marginLeft: 1,
                fontSize: { xs: 14, sm: 16 },
              }}
            >
              Adicionar Veículo
            </Typography>
            <Add sx={{ fontSize: { xs: 24, sm: 30 }, marginLeft: 2 }} />
          </Button>
        )}
      </Grid>
      <Grid item xs={12}>
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={50}
            sx={{
              borderRadius: 2,
              bgcolor: "grey.400",
            }}
          />
        ) : (
          <TextField
            placeholder="Pesquisar por Chassi/Modelo/Cliente em todos os veículos"
            fullWidth
            sx={{
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#303030",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                backgroundColor: "white",
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#303030",
                },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={handleSearchChange}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          ".MuiButtonGroup-grouped": {
            borderColor: "#5f5f5f",
          },
          "& .MuiButtonGroup-grouped:not(:last-of-type)": {
            borderColor: "#5f5f5f",
          },
        }}
      >
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={40}
            sx={{
              borderRadius: 2,
              bgcolor: "grey.400",
            }}
          />
        ) : (
          <ButtonGroup
            variant="contained"
            aria-label="Basic button group"
            fullWidth
          >
            <Button
              onClick={() => setComCliente(null)}
              sx={{
                backgroundColor: comCliente === null ? "#6f6f6f" : "#9f9f9f",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#5c5c5c",
                  color: "#fff",
                },
              }}
              variant={comCliente === null ? "contained" : "outlined"}
            >
              Todos Veículos
            </Button>
            <Button
              onClick={handleComClienteChange}
              sx={{
                backgroundColor: comCliente === true ? "#6f6f6f" : "#9f9f9f",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#5c5c5c",
                  color: "#fff",
                },
              }}
              variant={comCliente === true ? "contained" : "outlined"}
            >
              Com cliente
            </Button>
            <Button
              onClick={handleSemClienteChange}
              sx={{
                backgroundColor: comCliente === false ? "#6f6f6f" : "#9f9f9f",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#5c5c5c",
                  color: "#fff",
                },
              }}
              variant={comCliente === false ? "contained" : "outlined"}
            >
              Sem cliente
            </Button>
          </ButtonGroup>
        )}
      </Grid>
      <Grid item xs={6}>
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={30}
            width={140}
            sx={{
              borderRadius: 2,
              bgcolor: "grey.400",
            }}
          />
        ) : (
          <Typography
            variant="overline"
            sx={{ fontSize: { xs: 12, sm: 14 }, fontWeight: 500 }}
          >
            {`Total de veículos: ${vehicles}`}
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default HeaderVehicle;
